import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const MapIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.9082 6.48335V14.5917C1.9082 16.175 3.0332 16.825 4.39987 16.0417L6.3582 14.925C6.7832 14.6834 7.49154 14.6584 7.9332 14.8834L12.3082 17.075C12.7499 17.2917 13.4582 17.275 13.8832 17.0334L17.4915 14.9667C17.9499 14.7 18.3332 14.05 18.3332 13.5167V5.40835C18.3332 3.82502 17.2082 3.17502 15.8415 3.95835L13.8832 5.07502C13.4582 5.31669 12.7499 5.34169 12.3082 5.11669L7.9332 2.93335C7.49154 2.71669 6.7832 2.73335 6.3582 2.97502L2.74987 5.04169C2.2832 5.30835 1.9082 5.95835 1.9082 6.48335Z"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.13379 3.33337V14.1667V3.33337Z" fill="#292D32" />
      <path
        d="M7.13379 3.33337V14.1667"
        stroke="#292D32"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1084 5.51672V16.6667"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
